import { extend, override } from 'flarum/common/extend';
import LogInModal from 'flarum/forum/components/LogInModal';

extend(LogInModal.prototype, 'fields', function(items) {
  items.remove('identification');
  items.remove('password');
  items.remove('remember');
  items.remove('submit');
});

override(LogInModal.prototype, 'footer', function() {
  return;
});

override(LogInModal.prototype, 'content', function() {
  return [<div className="Modal-body">Welcome to the CloudGG Community Forum!<br></br>This is your place to connect with other GeForce NOW Powered by Pentanet Players and our Support Team to discuss the service, read FAQs, provide feedback, report bugs, and help out fellow gamers.<br></br><br></br>Please log in using your CloudGG account by clicking the button below.<br></br><br></br>{this.body()}</div>];
});
